import {
  GiftDetailsComponent, GiftRedeemComponent, GiftDetailsResolverService,
  GiftRedeemResolverService, GiftsListResolverService, GiftsListViewComponent
} from '@app/gifts';
import {
  VisitDetailsResolverService
} from '@app/shared/guards';
import { Routes } from "@angular/router";

export const giftsModuleRoutes: Routes = [
  {
    path: 'gifts',
    children: [
      {
        path: 'list/:visitId',
        data: { bodyCssClass: 'bjootify-gift-list' },
        component: GiftsListViewComponent,
        resolve: {
          gifts: GiftsListResolverService
        }
      },
      {
        path: 'details/:visitId/:giftId',
        data: { bodyCssClass: 'bjootify-gift-details' },
        component: GiftDetailsComponent,
        resolve: {
          giftDetails: GiftDetailsResolverService,
          visitDetails: VisitDetailsResolverService
        }
      },
      {
        path: 'redeem/:giftCodeToken',
        data: { bodyCssClass: 'bjootify-gift-redeem' },
        component: GiftRedeemComponent,
        resolve: {
          giftRedeem: GiftRedeemResolverService
        }
      },
      { path: '**', redirectTo: '/', pathMatch: 'full' }
    ]
  }
];
